export default __webpack_public_path__ + "static/media/velocity-use-case-img3.0e0f9add.png";